/**
 * Created by Radoslaw on 2014-12-11.
 */

import { IMeasurementConfig, FPS_MEASUREMENT_LOGGER } from "./IMeasurements";

export class FpsMeasurementConfig implements IMeasurementConfig  {
    constructor() {
    }

    public get canBeExecutedManually(): boolean {
        return false;
    }

    public get canBeInterrupted(): boolean {
        return true;
    }

    public get pauseOnApplicationDeactivate(): boolean {
        return true;
    }

    public get delayInMilliseconds(): number {
        return 5000;
    }

    public get durationInMilliseconds(): number {
        return 30000;
    }

    public get minimalDurationInMilliseconds(): number {
        return 10000;
    }
}
